import jQuery from 'jquery';
import "select2";
import pl from "select2/src/js/select2/i18n/pl.js";

jQuery.fn.select2.defaults.set("theme", "bootstrap-5");
jQuery.fn.select2.defaults.set("language", pl);
jQuery.fn.select2.defaults.set("allowClear", false);
jQuery.fn.select2.defaults.set("placeholder", "---");

jQuery(document).ready(() => {
    jQuery(".select2")
        .select2()
        .on('select2:open', () => {
            document.querySelector('.select2-search__field').focus();
        });
});
